<script setup lang="ts">
import type { CalendarDate, Time } from "@internationalized/date"
import type { Location } from "@mmh/types"
import { InquiryType } from "@mmh/types/constants"
import type { HTMLAttributes } from "vue"
import type { RouteLocationRaw } from "vue-router"
import { TavoButton, TavoWidgetMode } from "~/components/tavo"
import { useTavoConfig } from "~/components/tavo/config"
import { TriggerType } from "~/composables/useInquiryAnalytics"
import { kebabCase } from "~/lib/case"
import { cn } from "~/lib/utils"
import { InquiryDialog } from "."

const { location, guests, date, time, type, class: cl, triggerType } = defineProps<{
    type: typeof InquiryType[keyof typeof InquiryType]
    location: Location
    guests?: number
    date?: CalendarDate
    time?: Time
    to?: RouteLocationRaw
    class?: HTMLAttributes["class"]
    triggerType?: TriggerType
}>()

const tavoConfig = useTavoConfig()
const tavoReferrer = computed(() => type)

const locationKey = computed(() => kebabCase(location.name))
</script>

<template>
    <TavoButton
        v-if="tavoConfig"
        :group="tavoConfig.group"
        :concept="tavoConfig.concept"
        :location="locationKey"
        :mode="TavoWidgetMode.Inquiry"
        :referrer="tavoReferrer"
    >
        <slot />
    </TavoButton>
    <InquiryDialog
        v-else
        :location
        :guests
        :date
        :time
        :type
        :trigger-type
        :class="cn(cl)"
    >
        <slot />
    </InquiryDialog>
</template>